import { render, staticRenderFns } from "./contactList.vue?vue&type=template&id=2198e268&scoped=true"
import script from "./contactList.vue?vue&type=script&lang=js"
export * from "./contactList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2198e268",
  null
  
)

export default component.exports